import { UserRole } from '@hms/shared';

/** The warehouse dashboard: where the central stock manager lands, and where picking the central site leads. */
export const WAREHOUSE_DASHBOARD_PATH = '/warehouse';

// The roles of the warehouse screens; the central stock manager uses them on the central site.
export const WAREHOUSE_ROLES: string[] = [UserRole.ADMIN, UserRole.HOSPITAL_ADMIN, UserRole.STOCK_MANAGER, UserRole.CENTRAL_STOCK_MANAGER];
